import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const HubAddUsers = makeStyles((theme: Theme) =>
    createStyles({
        headerInner: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: theme.spacing(3),
        },
        headerTitle: {
            fontSize: 36,
            display: "inline-flex",
            alignItems: "center",
        },
        bodyHeader: {
            padding: theme.spacing(2, 1),
        },
        intro: {
            fontSize: 16,
            color: theme.palette.secondary.main,
            marginBottom: theme.spacing(2),
        },
        toolbox: {
            display: "flex",
            alignItems: "center",
            padding: theme.spacing(0, 1),
        },
        filtersWrapper: {
            display: "flex",
            flex: 1,
            alignItems: "flex-end",
            "& > div": {
                display: "flex",
                flex: 1,
                alignItems: "flex-start",
                flexDirection: "column",
            },
        },
        label: {
            fontSize: 14,
            fontWeight: 500,
            color: theme.palette.text.primary,
            marginBottom: theme.spacing(0.5),
        },
        filterByNameInput: {
            width: "100%",
            "& .MuiInputBase-input": {
                height: 22,
            },
            "& .MuiInputAdornment-root .MuiSvgIcon-root": {
                fontSize: 16,
            },
        },
        selectField: {
            width: "100%",
            "& .MuiSelect-icon": {
                fontSize: 16,
                right: theme.spacing(2),
            },
        },
        invitationsButton: {
            height: theme.spacing(2),
            padding: 0,
            borderRadius: 0,
            minWidth: "auto",
            color: theme.palette.secondary.main,
            borderBottom: `1px solid ${theme.palette.secondary.main}`,
        },
        filterByRolePaper: {
            borderRadius: theme.spacing(4),
            border: `1px solid ${theme.palette.secondary.light}`,
            boxShadow: "0px 1px 3px 0px #0000001A 0px 1px 2px 0px #0000000F",
        },
        moreRolesChip: {
            width: 22,
            height: 20,
            fontSize: 10,
            fontWeight: 600,
            marginLeft: theme.spacing(0.5),
            borderRadius: theme.spacing(10),
            color: theme.palette.text.primary,
            background: theme.palette.background.paleBlue,
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        sectionTitle: {
            fontSize: 20,
            fontWeight: 600,
        },
        errorAlert: {
            justifyContent: "center",
        },
        errorIcon: {
            fontSize: 16,
            marginRight: theme.spacing(0.5),
            alignSelf: "center",
        },
        errorMessage: {
            fontSize: 16,
            fontWeight: 400,
            marginLeft: theme.spacing(0.5),
        },
        tablesWrapper: {
            display: "flex",
        },
        usersTable: {
            "& .MuiCheckbox-root": {
                padding: 0,
            },
        },
        selectButton: {
            padding: theme.spacing(0, 1),
            "& .MuiSvgIcon-root": {
                opacity: 1,
            },
            "&.Mui-disabled": {
                color: theme.palette.text.disabled,
                "& .MuiSvgIcon-root": {
                    opacity: 0.5,
                },
            },
        },
        tableHeader: {
            background: theme.palette.background.paleBlue,
            "& .MuiTableCell-root": {
                fontWeight: 700,
                borderBottom: `1px solid ${theme.palette.neutrals.main}`,
                padding: theme.spacing(1.5, 1),
                "&:nth-child(1)": {
                    lineHeight: 0,
                },
                "& .MuiCheckbox-root": {
                    padding: 0,
                },
                "& .MuiTypography-root": {
                    fontSize: 16,
                    fontWeight: 700,
                    color: theme.palette.text.primary,
                },
            },
        },
        selectedUsersTableWrapper: {
            display: "flex",
            flexDirection: "column",
        },
        selectedUsersTable: {
            flex: 1,
            background: theme.palette.background.green,
            "& .MuiCheckbox-root": {
                padding: 0,
            },
            "& $tableHeader": {
                background: theme.palette.background.green,
                "& .MuiTableCell-root": {
                    padding: theme.spacing(1.5, 1),
                    borderBottom: `1px solid ${theme.palette.neutrals.main}`,
                    "&:nth-child(2)": {
                        paddingLeft: 0,
                    },
                },
            },
            "& $tableBody": {
                "& .MuiTableCell-root": {
                    color: theme.palette.text.secondary,
                    paddingTop: theme.spacing(0.5),
                    paddingBottom: theme.spacing(0.5),
                    borderBottom: `1px solid ${theme.palette.neutrals.light}`,
                },
            },
        },
        cellWithSortButton: {
            display: "flex",
            alignItems: "center",
            marginLeft: -8,
        },
        sortButton: {
            fontSize: 14,
            color: theme.palette.neutrals.dark,
        },
        columnsButton: {
            color: theme.palette.button.active.to,
        },
        tableBody: {
            "& .MuiTableRow-root": {
                "&:hover": {
                    "& $addUserButton": {
                        opacity: "0.6 !important",
                        "&:hover": {
                            opacity: "1 !important",
                        },
                    },
                },
            },
            "& .MuiTableCell-root": {
                color: theme.palette.text.secondary,
                padding: theme.spacing(1.5, 1),
                "&:nth-child(1)": {
                    lineHeight: 0,
                },
                "&:nth-child(2)": {
                    paddingLeft: theme.spacing(0),
                },
                "&[data-hidden='true']": {
                    display: "none",
                },
            },
        },
        roleSelectMenuItem: {
            "& .MuiListItemText-primary": {
                fontSize: 16,
                fontWeight: 600,
                color: theme.palette.text.primary,
            },
            "& .MuiListItemText-secondary": {
                fontSize: 14,
                fontWeight: 500,
                color: theme.palette.text.disabled,
            },
        },
        addUserButton: {
            fontSize: 18,
            opacity: 0,
            color: theme.palette.success.main,
        },
        expandableRow: {
            "& .MuiTableCell-root": {
                background: theme.palette.background.grey,
                padding: theme.spacing(0.5, 3),
            },
            "& .MuiTypography-root": {
                fontSize: 12,
                fontWeight: 600,
            },
        },
        noDataWrapper: {
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            margin: theme.spacing(5, 0),
            "& .MuiTypography-root": {
                fontSize: 16,
                marginBottom: theme.spacing(2),
                "& + .MuiTypography-root": {
                    fontSize: 14,
                    color: theme.palette.text.secondary,
                    marginTop: theme.spacing(-1.5),
                },
            },
        },
        confirmationWrapper: {
            width: "100%",
            maxWidth: 612,
            background: theme.palette.common.white,
            padding: theme.spacing(2),
        },
    })
);

export default HubAddUsers;
